import { HitListItem, HitListItemProps } from "./HitListItem";

export type HitGridItemProps = HitListItemProps;

export const HitGridItem = (props: HitGridItemProps) => {
  return <HitListItem {...props} viewMode="notes" />;
};
